export class NumberUtils {
  static numberFormat(number: Number) {
    let returnString = number?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return returnString;
  }
}